import * as React from 'react';
import { FormattedMessage } from "react-intl";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './loading.scss';

library.add(faSync);
// todo fix link
class Loading extends React.Component {
    render() {
        return ( 
            <div className="loadingContnet">
               <h2><FontAwesomeIcon icon="sync" className="fa-spin"/> <FormattedMessage id="General.loading" defaultMessage="Loading please wait" /> </h2>
            </div>
        )
    }
}

export default Loading;
